import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
@Component({
    selector: 'app-claim-detail',
    templateUrl: './claim-detail.component.html',
    styleUrls: ['./claim-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimDetailComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
